/* eslint-disable
    no-param-reassign,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('RootAccountActions', ($q, $state, $rootScope, AccountService, ContractService, DataAccess, DataAccessSearch, ApiCons, ApiUser, ReferencesService,
    Contacts, BoFeaturesService, SocketFactory, MetaWatcher, AlertManager, ErrorCatcher) => {
    const initAccount = ($scope, search, accountId, customerId, contractId) => function (dispatch) {
        AccountService.reset()
        ContractService.reset()
        const clientPrefix = $rootScope.clientPrefix
        const contractElecPrefix = $rootScope.contractElecPrefix
        const contractGasPrefix = $rootScope.contractGasPrefix

        if (search != null) {
            if (search.length > 9) {
                accountId = search
            } else if (search.startsWith(clientPrefix)) {
                customerId = search
            } else if (search.startsWith(contractElecPrefix) || search.startsWith(contractGasPrefix)) {
                customerId = null
                contractId = search
            }
        }

        dispatch({ type: 'GET_ACCOUNT' })
        if (accountId) {
            return AccountService.fetchAccountById(accountId, undefined)
        } else if (customerId) {
            return AccountService.fetchAccount(customerId, contractId)
        } else if (contractId) {
            return AccountService.fetchAccountForContract(contractId)
        }
        return dispatch({ type: 'GET_ACCOUNT_NONE', error: { message: 'Il n\'y a pas de compte utilisateur sélectionné.' } })
    }

    const refreshAccount = () => function (dispatch, getState) {
        dispatch({ type: 'GET_ACCOUNT' })
        return AccountService.fetchAccount(getState().account.customer_id, getState().currentContract && getState().currentContract.id)
    }

    const onAccountFetched = (error, account, contractId, scope) => function (dispatch, getState) {
        if (!_.isEmpty(error)) {
            return dispatch({ type: 'GET_ACCOUNT_FAIL', error })
        }
        dispatch({ type: 'GET_CONTRACT' })
        let draftId
        dispatch({
            type: 'GET_ACCOUNT_DONE',
            account: account ?
                _.assign({}, account, { contractList: _.orderBy(_.concat(account.contractsElec || [], account.contractsGas || []), ['id_place', 'energy_type'], ['asc', 'asc']) }) :
                account,
        })
        if (account) {
            if (!_.isEmpty(account.contractsElec) || !_.isEmpty(account.contractsGas)) {
                if (!contractId) {
                    dispatch(updateContract(account, account.contractsElec[0] || account.contractsGas[0]))
                } else {
                    const contractFound = _.find(account.contractsElec, { id: contractId }) || _.find(account.contractsGas, { id: contractId })
                    if (contractFound) {
                        dispatch(updateContract(account, contractFound))
                    } else {
                        draftId = contractId
                    }
                }
            } else {
                dispatch({ type: 'GET_CONTRACT_DONE' })
            }
            dispatch(fetchContractDraft(draftId))
            MetaWatcher.notif('CONTACTS_CHANGED')
            if (scope) {
                SocketFactory.join(account.id, scope)
            }
        }
    }

    const fetchContractDraft = (contractId) => function (dispatch, getState) {
        dispatch({ type: 'GET_CONTRACT_DRAFT' })
        return DataAccessSearch({ orderBy: '-modification_ts' }).search({ resource: 'contractdrafts', id_account: getState().account.id, status: [0, 90], withRelated: 'providerOffer,prm' })
        .$promise.then((contractdrafts) => {
            dispatch({
                type: 'GET_CONTRACT_DRAFT_DONE',
                contractDrafts: _.map(contractdrafts, (contractDraft) => _.assign({}, contractDraft, { isContractDraft: true })),
            })
            if (contractId) {
                const selectedContractDraftIndex = _.findIndex(contractdrafts, { id: contractId })
                if (selectedContractDraftIndex > -1) {
                    return dispatch({ type: 'UPDATE_CONTRACT_TAB', index: 10000 + selectedContractDraftIndex })
                }
                AlertManager.error(`Le contrat ou l'ébauche recherché n'existe pas.`)
                if (getState().account.contractList.length) { // if contract not found load the first one if existing
                    dispatch(onAccountFetched(null, getState().account))
                }
            }
        }).catch((error) => {
            ErrorCatcher(error)
            return dispatch({ type: 'GET_CONTRACT_DRAFT_FAIL', error })
        })
    }

    const updateContract = (account, currentContract) => function (dispatch, getState) {
        if (currentContract && !currentContract.isContractDraft) {
            // DISABLE CONTRACT COMPONENT TO AVOID NULL VALUE WHEN LOADING DATA
            dispatch({ type: 'GET_CONTRACT' })
            const fetchFunction = currentContract.energy_type === 'ELEC' ? DataAccess.contractElecInfoLight : DataAccess.contractGasInfoLight
            // LOAD CONTRACT FROM SERVER
            return fetchFunction({ id_account: currentContract.id_account, id_contract: currentContract.id }).$promise.then((contract) => {
                // LOAD STUFF IF IT'S A CONTRACT
                if (!contract.isContractDraft && BoFeaturesService.isFeatureOn('securityDeposit')) {
                    // LOAD DEPOSIT
                    return DataAccess.depositBalance({ id_contract: contract.id }).$promise.then((balanceResult) => {
                        if (balanceResult) {
                            contract.depositBalance = balanceResult.deposit_balance
                            contract.depositDate = balanceResult.payment_date
                        }
                    }).then(() => {
                        // LOAD DEPOSIT FLAG
                        return DataAccess.isDepositNeeded({ id_contract: contract.id }).$promise.then((result) => {
                            contract.isDepositNeeded = result.depositNeeded
                            if (result.depositNeeded) {
                                return DataAccess.getDepositFlag({ id_contract: contract.id }).$promise.then((flagResult) => {
                                    contract.isRedFlag = flagResult.redFlag
                                    return contract
                                })
                            }
                            return contract
                        })
                    })
                }
                return contract
            }).then((contract) => {
                // NOTIFY CONTRACT UPDATED
                dispatch({ type: 'GET_CONTRACT_DONE' })

                // UPDATE LOADED CONTRACT
                dispatch({ type: 'UPDATE_ACCOUNT_CONTRACT', contract })

                // CHANGE URL
                $state.go('userInfoOnContract', { customerId: account.customer_id, contractId: contract.id }, { notify: false })

                // NOTIFY CONTRACT UPDATED
                if (!contract.isContractDraft) {
                    ContractService.update(contract) // Required to notify old component
                    dispatch({ type: 'SET_CURRENT_CONTRACT', contract })
                }

                // UPDATE SELECTED TAB
                dispatch({ type: 'UPDATE_CONTRACT_TAB', index: _.findIndex(getState().account.contractList, { id: contract.id }) + 1 })
            }).catch((error) => {
                ErrorCatcher(error)
                dispatch({ type: 'GET_CONTRACT_FAIL', error })
            })
        }
        // CHANGE URL
        $state.go('userInfoOnContract', { customerId: account.customer_id, contractId: currentContract && currentContract.id }, { notify: false })
    }

    const refreshTab = () => (dispatch) => {
        dispatch({ type: 'REFRESH_TAB' })
    }

    const refreshTabDone = () => (dispatch) => {
        dispatch({ type: 'REFRESH_TAB_DONE' })
    }

    return {
        initAccount,
        refreshAccount,
        onAccountFetched,
        fetchContractDraft,
        updateContract,
        refreshTab,
        refreshTabDone,
    }
})
